export let action = {
  DPCALCULATION: "Data Point Calculation",
  EDIT: "Edit",
  ADD_NEW_BATCH: "Add New Batch",
  ADD_NEW_BATCHES: "Add New Batches",
  CREATE_PROJECT: "Create New Project",
  E_SIGN: "E-Sign",
  LOGOUT: "Logout",
  LOGO: "CPV-Auto Batch Processing Platform",
  SEARCH: "Search",
  PROJECT: "Project",
  BATCH: "Batch",
  // UPLOAD: "Upload",
  CLEAR: "Clear",
  DRAW: "Draw Signature",
  UPLOAD: "Uploaded Signature",
  REJECTION_PROMPT: "Do you want to reject the cell?",
  REJECTION_REMARK: "Cell Rejection Remark.",
  SETTINGS: "Settings",
  SEARCH_BATCH: "Search Batch..",
  CREATE_MULTIPLE_BATCH: "Create Multiple Batches",
  Folder: "Folder",
  File: "File",
  PREVIEW_FILES: "Box Files",
  APPROVE: "Approve",
  REJECT: "Reject",
  TASKSTATUS: "Task Status",
  AUDITTRAIL: "Audit Trail",
  INVESTIGATION: "Search & Investigate",
  VISUALIZATION: "Visualization",
  DATAPREVIEW: "Data Preview",
  LOGS: "Logs",
  TASKSTATUSNEW: "Task Status New",
  AUDITTRAILNEW: "Audit Trail New",
  TEMPLATE: "Template",
  UPLOADED_FILES: "Uploaded Files",
  FILE_NAME_SEARCH: "Search File",
};
